import styled from 'styled-components';
import { Button } from '@material-ui/core';

const ButtonStyles = styled(Button)`
	.MuiButton-label {
		font-size: 16px;
		font-weight: 400;
		text-transform: capitalize;
		color: ${props => props.textColor};
	}

	&.MuiButton-root {
		border: 2px solid;
		width: 152px;
		padding: 5px 0px;
		border-color: ${props => props.theme.palette.primary.main};
	}

	&.MuiButton-outlinedPrimary {
		border-color: ${props => props.theme.label.color};
		&:hover {
			border-width: 2px;
		}
	}

	&.MuiButton-contained.Mui-disabled {
		box-shadow: none;
		background-color: #bbb;
		border-color: #bbb;
	}
`;

export default ButtonStyles;
